import { createSelector } from "reselect";

const selectTransactions = (state) => state.transactions;

export const selectTransactionsData = createSelector(
  [selectTransactions],
  (transactions) => transactions.transactions
);

export const selectIsFetchingTransactions = createSelector(
  [selectTransactions],
  (transactions) => transactions.isFetchingTransactions
);

export const selectIsVerifyingTransaction = createSelector(
  [selectTransactions],
  (transactions) => transactions.isVerifyingTransaction
);

export const selectFilteredTransactions = createSelector(
  [selectTransactions],
  (transactions) => transactions.filteredTransactions
);